<template>
  <flat-pickr
    class="w-full"
    :config="config"
    v-model="inputValue"
    placeholder="Tanggal Surat"
  />
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  components: {
    flatPickr
  },
  props: {
    config: {
      type: Object,
      default: () => {
        return {
          dateFormat: "Y-m-d",
          time_24hr: true
        };
      }
    },
    value: {
      type: String
    }
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>

<style>
.flatpickr-calendar.open {
  z-index: 100002;
}
</style>
